// @ts-strict-ignore
import type { Module } from 'vuex'

import type { ConfigState } from '../../models'

import { LoadInstancesAction } from '../../store/config/actions/load-instances.action'
import { CONFIG_CONSTS } from '../../store/config/config.consts'

import { BrowseKpisGetter } from '../../store/config/getters/browse-kpis.getter'
import { CurrentInstanceGetter } from '../../store/config/getters/current-instance.getter'
import { InstancesGetter } from '../../store/config/getters/instances.getter'
import { SearchKpisGetter } from '../../store/config/getters/search-kpis.getter'
import { SetInstancesMutation } from '../../store/config/mutations/set-instances.mutation'
import { ResetAction } from '../common/actions/reset.action'
import { ResetMutation } from '../common/mutations/reset.mutation'

export const CONFIG_MODULE: Module<ConfigState, any> = {
  namespaced: true,

  initialState: (): ConfigState => ({
    instances: [],
  }),
  state: (): ConfigState => CONFIG_MODULE.initialState(),

  getters: {
    [CONFIG_CONSTS.getters.instances]: InstancesGetter.execute,
    [CONFIG_CONSTS.getters.currentInstance]: CurrentInstanceGetter.execute,
    [CONFIG_CONSTS.getters.searchKpis]: SearchKpisGetter.execute,
    [CONFIG_CONSTS.getters.browseKpis]: BrowseKpisGetter.execute,
  },

  actions: {
    [CONFIG_CONSTS.actions.loadInstances]: LoadInstancesAction.execute,

    [CONFIG_CONSTS.actions.reset]: context =>
      ResetAction.execute(context, CONFIG_MODULE.initialState()),
  },

  mutations: {
    [CONFIG_CONSTS.mutations.setInstances]: SetInstancesMutation.execute,

    [CONFIG_CONSTS.mutations.reset]: ResetMutation.execute,
  },
}
